import React, { useState } from 'react';
import styles from './LaboratoryResults.module.scss';
import useFlatData from '../../../Base/Hooks/useFlatData';
import Checkbox from '../../../../Components/Base/Checkbox/Checkbox';
import LinkButton from '../../../../Components/Button/LinkButton';
import { Theme } from '../../../../Enums/Theme.enum';
import useLaboratoryResults from '../../Hooks/useLaboratoryResults';
import LaboratoryResultsFiler from './LaboratoryResultsFilter';
import LaboratoryResultsList from './LaboratoryResultsList';
import {
	LaboratoryResultResult,
	useHideSeenLaboratoryResultsMutation,
} from '../../../../graphql/graphql';

const LaboratoryResults: React.FC = () => {
	const [markAsSeen] = useHideSeenLaboratoryResultsMutation();
	const { getLaboratoryResults, getNextPage, data, isLoading, page, setPage } =
		useLaboratoryResults();

	const { flatData, hasMoreData, loadData, setFilter } = useFlatData(
		getLaboratoryResults,
		{
			data: data?.laboratoryResults?.data,
			totalPages: data?.laboratoryResults?.meta?.totalPages,
			page: data?.laboratoryResults?.meta?.page,
		},
		page,
		setPage,
		{},
	);

	const [isAllChecked, setIsAllChecked] = useState(false);
	const [selectedItems, setSelectedItems] = useState<LaboratoryResultResult[]>(
		[],
	);

	const handleCheckAllItems = () => {
		setIsAllChecked(prev => !prev);
		if (isAllChecked) {
			setSelectedItems([]);
		}
	};

	const handleAddItemToSelected = (
		item: LaboratoryResultResult,
		add: boolean,
	) => {
		if (!item) {
			return null;
		}
		setSelectedItems(prev => {
			if (add) {
				return [...prev, item];
			}
			return prev.filter(({ id }) => id !== item.id);
		});
	};

	const handleMarkAsSeen = async () => {
		if (isAllChecked) {
			await markAsSeen({
				input: {
					isSeen: true,
					all: true,
				},
			});
		} else {
			await markAsSeen({
				input: {
					isSeen: true,
					laboratoryResultIds: selectedItems.map(item => {
						return item.id;
					}),
				},
			});
		}
		loadData(true);
	};

	return (
		<div className={styles.wrapper}>
			<LaboratoryResultsFiler onFilter={setFilter} />
			<div className={styles.options}>
				<Checkbox
					tx={'base.everything'}
					value={isAllChecked}
					onChange={handleCheckAllItems}
					firstUpper
				/>
				<div className={styles.seenWrapper}>
					<img src={'/dist/icons/eye.svg'} />
					<LinkButton
						title={'base.markAsSeen'}
						theme={Theme.BLUE}
						onClick={handleMarkAsSeen}
					/>
				</div>
			</div>
			<LaboratoryResultsList
				flatData={flatData}
				isLoading={isLoading}
				hasMoreData={hasMoreData}
				onLoadMore={getNextPage}
				onRefresh={loadData}
				onItemSelect={handleAddItemToSelected}
				isAllSelected={isAllChecked}
			/>
		</div>
	);
};
export default LaboratoryResults;
